// extracted by mini-css-extract-plugin
export var option = "_5j-1";
export var optionActive = "_5j-2";
export var pill = "_5j-0";